// import { newsData } from "../../Data/NewsAnnouncementData";
// import Paper from "@mui/material/Paper";
// import ImageList from "@mui/material/ImageList";
// import ImageListItem from "@mui/material/ImageListItem";
// import Blink from "react-blink-text";
// import Breadcrumb from "../../Components/Breadcrumb";
// import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
// import { Grid } from "@mui/material";
// import { NewsIcon } from "../../Components/SvgIcons";
// import { useEffect } from "react";
// import { useLocation } from "react-router-dom";

// export default function NewsAnnouncementPage() {
//   // window.scrollTo(0, 270);
//   const location = useLocation();
//   const searchParams = new URLSearchParams(location.search);
//   const id = searchParams.get("id");

//   useEffect(() => {
//     window.scrollTo(0, 270);

//     if (id) {
//       setTimeout(() => {
//         const section = document.getElementById(id);
//         if (section) {
//           const headerOffset = 150; // adjust as per your header height
//           const elementPosition =
//             section.getBoundingClientRect().top + window.pageYOffset;
//           const offsetPosition = elementPosition - headerOffset;

//           window.scrollTo({
//             top: offsetPosition,
//             behavior: "smooth",
//           });
//         }
//       }, 500);
//     }
//   }, [id]);
//   const displayedNews = id
//     ? newsData.filter((item) => item.id === id)
//     : newsData;
//   return (
//     <>
//       <div className="bredDivMob">
//         <Breadcrumb
//           pageTitle={
//             <h3 className="fs-3 mt-0 text-bold decorated text-light">
//               News Announcement
//             </h3>
//           }
//         />
//       </div>
//       <div className="bredDivDesk">
//         <Breadcrumb
//           pageTitle={
//             <h3 className="fs-3 mt-0 text-bold decorated text-light">
//               News Announcement
//             </h3>
//           }
//         />
//       </div>
//       <div className="bg-light m-0 py-3">
//         <Paper elevation={0} className="mx-5 my-5 bg-light">
//           {displayedNews.map((items, index) => (
//             <div className="upcoming-texts" key={index} id={items.id}>
//               <div className="home-card-content">
//                 <Grid container>
//                   <Grid xs={0.5}>
//                     <NewsIcon />
//                   </Grid>
//                   <Grid xs={11.5}>
//                     <h5 className="home-card-title g-2 fs-5">{items.title}</h5>
//                     <div className="fs-5 g-3 mt-2">
//                       {items.Doc.pdf.length !== 0 && (
//                         <a
//                           href={items.Doc.pdf}
//                           target="_blank"
//                           className="fs-6 g-3 mt-2 mx-lg-4"
//                           rel="noreferrer"
//                         >
//                           <PictureAsPdfIcon className="pdficon" /> view more...
//                         </a>
//                       )}
//                     </div>
//                     <div className="d-flex flex-wrap">
//                       <ImageList
//                         sx={{ width: 700 }}
//                         cols={3}
//                         gap={8}
//                         className="mt-3 mb-2 mx-lg-4"
//                       >
//                         {items.Doc.image.map((image, imageIndex) => (
//                           <ImageListItem key={imageIndex}>
//                             <a
//                               href={items?.link}
//                               target="_blank"
//                               rel="noreferrer"
//                             >
//                               <img
//                                 className="rounded"
//                                 src={image}
//                                 alt={`${imageIndex + 1}`}
//                               />
//                             </a>
//                           </ImageListItem>
//                         ))}
//                       </ImageList>
//                     </div>
//                     <div className="home-card-body fs-6 mt-3 mx-lg-4 text-justify">
//                       {items.description}
//                     </div>{" "}
//                     {/* Render news body */}
//                     <div className="Application home-card-Footer mt-3 mx-3">
//                       <Blink
//                         color="gray"
//                         text={items.updatedDate}
//                         fontSize={15}
//                       ></Blink>
//                     </div>
//                   </Grid>
//                 </Grid>
//               </div>
//             </div>
//           ))}
//         </Paper>
//       </div>
//     </>
//   );
// }

// import { useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import { newsData } from "../../Data/NewsAnnouncementData";
// import Paper from "@mui/material/Paper";
// import ImageList from "@mui/material/ImageList";
// import ImageListItem from "@mui/material/ImageListItem";
// import Blink from "react-blink-text";
// import Breadcrumb from "../../Components/Breadcrumb";
// import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
// import ArticleIcon from "@mui/icons-material/Article";
// import PlayCircleIcon from "@mui/icons-material/PlayCircle";
// import { Grid, Box } from "@mui/material";
// import { NewsIcon } from "../../Components/SvgIcons";

// // Check if link is YouTube
// const isYouTubeLink = (url) =>
//   url && (url.includes("youtube.com") || url.includes("youtu.be"));

// // Convert any YouTube URL to embed URL
// const getYouTubeEmbedUrl = (url) => {
//   if (!url) return null;
//   const shortMatch = url.match(/youtu\.be\/([a-zA-Z0-9_-]+)/);
//   if (shortMatch) return `https://www.youtube.com/embed/${shortMatch[1]}`;
//   const longMatch = url.match(/[?&]v=([a-zA-Z0-9_-]+)/);
//   if (longMatch) return `https://www.youtube.com/embed/${longMatch[1]}`;
//   return null;
// };

// export default function NewsAnnouncementPage() {
//   const location = useLocation();
//   const searchParams = new URLSearchParams(location.search);
//   const id = searchParams.get("id");

//   useEffect(() => {
//     window.scrollTo(0, 270);
//     if (id) {
//       setTimeout(() => {
//         const section = document.getElementById(id);
//         if (section) {
//           const headerOffset = 150;
//           const elementPosition = section.getBoundingClientRect().top + window.pageYOffset;
//           const offsetPosition = elementPosition - headerOffset;
//           window.scrollTo({ top: offsetPosition, behavior: "smooth" });
//         }
//       }, 500);
//     }
//   }, [id]);

//   const displayedNews = id ? newsData.filter((item) => item.id === id) : newsData;

//   return (
//     <>
//       <div className="bredDivMob">
//         <Breadcrumb pageTitle={<h3 className="fs-3 mt-0 text-bold decorated text-light">News Announcement</h3>} />
//       </div>
//       <div className="bredDivDesk">
//         <Breadcrumb pageTitle={<h3 className="fs-3 mt-0 text-bold decorated text-light">News Announcement</h3>} />
//       </div>

//       <div className="bg-light m-0 py-3">
//         <Paper elevation={0} className="mx-5 my-5 bg-light">
//           {displayedNews.map((items) => {
//             const hasImage = items.Doc.image.length > 0;
//             const hasLocalVideo = !!items.Doc?.video;
//             const hasYouTube = isYouTubeLink(items.link);
//             const embedUrl = hasYouTube ? getYouTubeEmbedUrl(items.link) : null;

//             return (
//               <div className="upcoming-texts" key={items.id} id={items.id}>
//                 <div className="home-card-content">

//                   {/* 1. Local video file */}
//                   {hasLocalVideo && (
//                     <Box sx={{ mb: 3, borderRadius: 3, overflow: "hidden" }}>
//                       <video
//                         controls
//                         style={{ width: "100%", maxHeight: 400, borderRadius: 12, background: "#000" }}
//                       >
//                         <source src={items.Doc.video} type="video/mp4" />
//                         Your browser does not support the video tag.
//                       </video>
//                     </Box>
//                   )}

//                   {/* 2. YouTube embed */}
//                   {!hasLocalVideo && hasYouTube && embedUrl && (
//                     <Box sx={{ mb: 3, borderRadius: 3, overflow: "hidden" }}>
//                       <iframe
//                         width="100%"
//                         height="380"
//                         src={embedUrl}
//                         title={items.title}
//                         frameBorder="0"
//                         allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//                         allowFullScreen
//                         style={{ borderRadius: 12, display: "block" }}
//                       />
//                     </Box>
//                   )}

//                   {/* 3. Image banner (no video) */}
//                   {!hasLocalVideo && !hasYouTube && hasImage && (
//                     <Box sx={{ mb: 3, borderRadius: 3, overflow: "hidden", maxHeight: 350 }}>
//                       <img
//                         src={items.Doc.image[0]}
//                         alt={items.title}
//                         style={{ width: "100%", maxHeight: 350, objectFit: "cover", borderRadius: 12 }}
//                       />
//                     </Box>
//                   )}

//                   {/* 4. Fallback placeholder */}
//                   {!hasLocalVideo && !hasYouTube && !hasImage && (
//                     <Box sx={{
//                       mb: 3, borderRadius: 3, height: 160,
//                       background: "linear-gradient(135deg, #a70606, #ff6b6b)",
//                       display: "flex", alignItems: "center", justifyContent: "center"
//                     }}>
//                       <ArticleIcon sx={{ color: "white", fontSize: 72, opacity: 0.7 }} />
//                     </Box>
//                   )}

//                   <Grid container>
//                     <Grid xs={0.5}>
//                       <NewsIcon />
//                     </Grid>
//                     <Grid xs={11.5}>
//                       <h5 className="home-card-title g-2 fs-5">{items.title}</h5>

//                       {/* PDF */}
//                       {items.Doc.pdf.length !== 0 && (
//                         <div className="fs-5 g-3 mt-2">
//                           <a href={items.Doc.pdf} target="_blank" className="fs-6 g-3 mt-2 mx-lg-4" rel="noreferrer">
//                             <PictureAsPdfIcon className="pdficon" /> View PDF
//                           </a>
//                         </div>
//                       )}

//                       {/* Image grid (more than 1 image) */}
//                       {items.Doc.image.length > 1 && (
//                         <div className="d-flex flex-wrap">
//                           <ImageList sx={{ width: 700 }} cols={3} gap={8} className="mt-3 mb-2 mx-lg-4">
//                             {items.Doc.image.map((image, imageIndex) => (
//                               <ImageListItem key={imageIndex}>
//                                 <img className="rounded" src={image} alt={`${imageIndex + 1}`} />
//                               </ImageListItem>
//                             ))}
//                           </ImageList>
//                         </div>
//                       )}

//                       {/* Description */}
//                       <div className="home-card-body fs-6 mt-3 mx-lg-4 text-justify">
//                         {items.description}
//                       </div>

//                       {/* Open on YouTube link (below embed) */}
//                       {hasYouTube && (
//                         <div className="mt-2 mx-lg-4">
//                           <a href={items.link} target="_blank" rel="noreferrer" style={{ color: "steelblue", fontSize: 14 }}>
//                             <PlayCircleIcon fontSize="small" sx={{ mr: 0.5, verticalAlign: "middle" }} />
//                             Open on YouTube
//                           </a>
//                         </div>
//                       )}

//                       {/* External link (non-YouTube) */}
//                       {items.link && !hasYouTube && (
//                         <div className="mt-2 mx-lg-4">
//                           <a href={items.link} target="_blank" rel="noreferrer" style={{ color: "steelblue", fontSize: 14 }}>
//                             🔗 View Link
//                           </a>
//                         </div>
//                       )}

//                       <div className="Application home-card-Footer mt-3 mx-3">
//                         <Blink color="gray" text={items.updatedDate} fontSize={15} />
//                       </div>
//                     </Grid>
//                   </Grid>

//                 </div>
//               </div>
//             );
//           })}
//         </Paper>
//       </div>
//     </>
//   );
// }


import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { newsData } from "../../Data/NewsAnnouncementData";
import Paper from "@mui/material/Paper";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import Blink from "react-blink-text";
import Breadcrumb from "../../Components/Breadcrumb";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ArticleIcon from "@mui/icons-material/Article";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import { Grid, Box } from "@mui/material";
import { NewsIcon } from "../../Components/SvgIcons";

// Check if link is YouTube
const isYouTubeLink = (url) =>
  url && (url.includes("youtube.com") || url.includes("youtu.be"));

// Convert any YouTube URL to embed URL
const getYouTubeEmbedUrl = (url) => {
  if (!url) return null;
  const shortMatch = url.match(/youtu\.be\/([a-zA-Z0-9_-]+)/);
  if (shortMatch) return `https://www.youtube.com/embed/${shortMatch[1]}`;
  const longMatch = url.match(/[?&]v=([a-zA-Z0-9_-]+)/);
  if (longMatch) return `https://www.youtube.com/embed/${longMatch[1]}`;
  return null;
};

export default function NewsAnnouncementPage() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");

  useEffect(() => {
    window.scrollTo(0, 270);
    if (id) {
      setTimeout(() => {
        const section = document.getElementById(id);
        if (section) {
          const headerOffset = 150;
          const elementPosition =
            section.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - headerOffset;
          window.scrollTo({ top: offsetPosition, behavior: "smooth" });
        }
      }, 500);
    }
  }, [id]);

  const displayedNews = id
    ? newsData.filter((item) => item.id === id)
    : newsData;

  return (
    <>
      <div className="bredDivMob">
        <Breadcrumb
          pageTitle={
            <h3 className="fs-3 mt-0 text-bold decorated text-light">
              News Announcement
            </h3>
          }
        />
      </div>
      <div className="bredDivDesk">
        <Breadcrumb
          pageTitle={
            <h3 className="fs-3 mt-0 text-bold decorated text-light">
              News Announcement
            </h3>
          }
        />
      </div>

      <div className="bg-light m-0 py-3">
        <Paper elevation={0} className="mx-5 my-5 bg-light">
          {displayedNews.map((items) => {
            const hasImage = items.Doc.image.length > 0;
            const hasLocalVideo = !!items.Doc?.video;
            const hasYouTube = isYouTubeLink(items.link);
            const embedUrl = hasYouTube ? getYouTubeEmbedUrl(items.link) : null;

            return (
              <div className="upcoming-texts" key={items.id} id={items.id}>
                <div className="home-card-content">

                  {/* 1. Local video file */}
                  {hasLocalVideo && (
                    <Box sx={{ mb: 3, borderRadius: 3, overflow: "hidden" }}>
                      <video
                        controls
                        style={{
                          width: "100%",
                          maxHeight: 400,
                          borderRadius: 12,
                          background: "#000",
                        }}
                      >
                        <source src={items.Doc.video} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                    </Box>
                  )}

                  {/* 2. YouTube embed */}
                  {!hasLocalVideo && hasYouTube && embedUrl && (
                    <Box sx={{ mb: 3, borderRadius: 3, overflow: "hidden" }}>
                      <iframe
                        width="100%"
                        height="380"
                        src={embedUrl}
                        title={items.title}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        style={{ borderRadius: 12, display: "block" }}
                      />
                    </Box>
                  )}

                  {/* 3. Image banner — ONLY if no video AND no link */}
                  {!hasLocalVideo && !items.link && hasImage && (
                    <Box
                      sx={{
                        mb: 3,
                        borderRadius: 3,
                        overflow: "hidden",
                        maxHeight: 350,
                      }}
                    >
                      <img
                        src={items.Doc.image[0]}
                        alt={items.title}
                        style={{
                          width: "100%",
                          maxHeight: 350,
                          objectFit: "cover",
                          borderRadius: 12,
                        }}
                      />
                    </Box>
                  )}

                  {/* 4. Fallback placeholder — only if truly nothing */}
                  {!hasLocalVideo && !items.link && !hasImage && (
                    <Box
                      sx={{
                        mb: 3,
                        borderRadius: 3,
                        height: 160,
                        background:
                          "linear-gradient(135deg, #a70606, #ff6b6b)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <ArticleIcon
                        sx={{ color: "white", fontSize: 72, opacity: 0.7 }}
                      />
                    </Box>
                  )}

                  {/* CONTENT */}
                  <Grid container>
                    <Grid xs={0.5}>
                      <NewsIcon />
                    </Grid>
                    <Grid xs={11.5}>
                      <h5 className="home-card-title g-2 fs-5">
                        {items.title}
                      </h5>

                      {/* PDF */}
                      {items.Doc.pdf.length !== 0 && (
                        <div className="fs-5 g-3 mt-2">
                          <a
                            href={items.Doc.pdf}
                            target="_blank"
                            className="fs-6 g-3 mt-2 mx-lg-4"
                            rel="noreferrer"
                          >
                            <PictureAsPdfIcon className="pdficon" /> View PDF
                          </a>
                        </div>
                      )}

                      {/* Image grid — show all images below content */}
                      {hasImage && (
                        <div className="d-flex flex-wrap">
                          <ImageList
                            sx={{ width: 700 }}
                            cols={3}
                            gap={8}
                            className="mt-3 mb-2 mx-lg-4"
                          >
                            {items.Doc.image.map((image, imageIndex) => (
                              <ImageListItem key={imageIndex}>
                                <img
                                  className="rounded"
                                  src={image}
                                  alt={`${imageIndex + 1}`}
                                />
                              </ImageListItem>
                            ))}
                          </ImageList>
                        </div>
                      )}

                      {/* Description */}
                      <div className="home-card-body fs-6 mt-3 mx-lg-4 text-justify">
                        {items.description}
                      </div>

                      {/* Open on YouTube link below embed */}
                      {hasYouTube && (
                        <div className="mt-2 mx-lg-4">
                          <a
                            href={items.link}
                            target="_blank"
                            rel="noreferrer"
                            style={{ color: "steelblue", fontSize: 14 }}
                          >
                            <PlayCircleIcon
                              fontSize="small"
                              sx={{ mr: 0.5, verticalAlign: "middle" }}
                            />
                            Open on YouTube
                          </a>
                        </div>
                      )}

                      {/* External non-YouTube link */}
                      {items.link && !hasYouTube && (
                        <div className="mt-2 mx-lg-4">
                          <a
                            href={items.link}
                            target="_blank"
                            rel="noreferrer"
                            style={{ color: "steelblue", fontSize: 14 }}
                          >
                            🔗 View Link
                          </a>
                        </div>
                      )}

                      <div className="Application home-card-Footer mt-3 mx-3">
                        <Blink
                          color="gray"
                          text={items.updatedDate}
                          fontSize={15}
                        />
                      </div>
                    </Grid>
                  </Grid>

                </div>
              </div>
            );
          })}
        </Paper>
      </div>
    </>
  );
}